import { t } from 'i18next'
import { z, ZodIssueCode } from 'zod'

import { origemTelefone } from '@/shared/interfaces/cliente.enums'
import { StringUtils } from '@/shared/utils'

const DDD_BRASIL = '55'
const DIGITOS_MAXIMOS_TELEFONE_BRASIL = 12
const DIGITOS_MAXIMOS_TELEFONE_INTERNACIONAL = 13

export const telefoneSchema = z
  .object({
    numero: z.string(),
    origem: z.nativeEnum(origemTelefone).default(origemTelefone.Brasil),
    principal: z.boolean().default(true),
  })
  .nullish()
  .superRefine((telefone, ctx) => {
    if (!telefone?.numero) {
      ctx.addIssue({ code: ZodIssueCode.custom, message: t('common:telefone.informe_telefone'), path: ['numero'] })
      return
    }

    const formattedNumber = StringUtils.removeSpecialCharacters(telefone?.numero)
    const isBrazilianPhone = formattedNumber.startsWith(DDD_BRASIL)

    if (telefone?.origem === origemTelefone.Brasil) {
      if (formattedNumber.length < DIGITOS_MAXIMOS_TELEFONE_BRASIL) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: t('common:telefone.validacao.minimo_brasil'),
          path: ['numero'],
        })
      }
    } else {
      const isTooShortFortIntl = isBrazilianPhone && formattedNumber.length <= DIGITOS_MAXIMOS_TELEFONE_INTERNACIONAL
      if (isTooShortFortIntl) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: t('common:telefone.validacao.minimo_internacional'),
          path: ['numero'],
        })
      }
    }
  })
